import { useSelector } from 'react-redux';
import { selectFeesFormData } from '../../redux-state/selectors';
import {
  VEHICLE_TYPE,
  FUEL_TYPE,
  TITLE_STATUS,
} from '../fees/contants'

function OutputLeftSide() {
  const feesFormData = useSelector(selectFeesFormData) || {};

  return (
    <div className='flex flex-col gap-4 w-[100%]'>
      <div className='flex flex-row text-gray-700 font-bold mb-2 items-center h-11'>
        Your Information
      </div>
      <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
        <div className='text-gray-700 mb-3 font-bold'>
          Location Information
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Zip Code:
              </div>
              <div className='font-medium'>
                {feesFormData?.zipCode}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                City:
              </div>
              <div className='font-medium'>
                {feesFormData?.city}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Outside city limits:
              </div>
              <div className='font-medium'>
                {feesFormData?.outSideCityLimit ? "Yes" : "No"}
              </div>
            </div>
          </div>

          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                State:
              </div>
              <div className='font-medium'>
                {feesFormData?.state}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                County:
              </div>
              <div className='font-medium'>
                {feesFormData?.country}
              </div>
            </div>
          </div>
        </div>

        <div className='border-t-2 border-t-gray-100 mb-3'>
          <div className='text-gray-700 mt-6 font-bold'>
            Vehicle Information <span className='text-xs text-gray-600 font-normal ml-1'>{feesFormData?.vinCode}</span>
          </div>
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Vehicle Type:
              </div>
              <div className='font-medium'>
                {VEHICLE_TYPE[feesFormData?.vehicleType]}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Fuel Type:
              </div>
              <div className='font-medium'>
                {FUEL_TYPE[feesFormData?.fuelType]}
              </div>
            </div>

            {feesFormData.gvw &&
              <div className='flex flex-row justify-between'>
                <div>
                  GVW:
                </div>
                <div className='font-medium'>
                  {Number(feesFormData?.gvw).toLocaleString()} lbs
                </div>
              </div>
            }

            <div className='flex flex-row justify-between'>
              <div>MSRP:</div>
              <div className='font-medium'>
                {Number(feesFormData?.msrp || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          </div>

          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Model Year:
              </div>
              <div className='font-medium'>
                {feesFormData?.modelYear}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Vehicle Weight:
              </div>
              <div className='font-medium'>
                {Number(feesFormData?.vehicleWeight).toLocaleString()} lbs
              </div>
            </div>
          </div>
        </div>

        <div className='border-t-2 border-t-gray-100 mb-3'>
          <div className='text-gray-700 mt-6 font-bold'>
            Transaction Information
          </div>
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Base Price:
              </div>
              <div className='font-medium'>
                {Number(feesFormData?.basePrice || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Transaction Type:
              </div>
              <div className='font-medium'>
                {feesFormData?.transactionType}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Plate Transfer:
              </div>
              <div className='font-medium'>
                {feesFormData?.plateTransfer ? "Yes": "No"}
              </div>
            </div>
          </div>

          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Plate Type:
              </div>
              <div className='font-medium'>
                {feesFormData?.plateType}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Title Status:
              </div>
              <div className='font-medium'>
                {TITLE_STATUS[feesFormData?.titleStatus]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OutputLeftSide;
